import React from 'react';

const AutoBus: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94897 16H16.051V18H7.94897V16Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5C2.44728 5 2 5.44728 2 6V16H3.051V18H0V6C0 4.34272 1.34272 3 3 3H21C22.6573 3 24 4.34272 24 6V18H20.949V16H22V6C22 5.44728 21.5527 5 21 5H3Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 16C4.67157 16 4 16.6716 4 17.5C4 18.3284 4.67157 19 5.5 19C6.32843 19 7 18.3284 7 17.5C7 16.6716 6.32843 16 5.5 16ZM2 17.5C2 15.567 3.567 14 5.5 14C7.433 14 9 15.567 9 17.5C9 19.433 7.433 21 5.5 21C3.567 21 2 19.433 2 17.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 16C17.6716 16 17 16.6716 17 17.5C17 18.3284 17.6716 19 18.5 19C19.3284 19 20 18.3284 20 17.5C20 16.6716 19.3284 16 18.5 16ZM15 17.5C15 15.567 16.567 14 18.5 14C20.433 14 22 15.567 22 17.5C22 19.433 20.433 21 18.5 21C16.567 21 15 19.433 15 17.5Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M23 12H1V10H23V12Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 11V4H18V11H16Z" />
    </svg>
  );
};

export default AutoBus;
